import {
    Pipe,
    PipeTransform,
} from '@angular/core';

@Pipe({
    name: 'join',
    pure: true,
    standalone: true,
})
export class JoinPipe implements PipeTransform {

    transform(value: any, separator = ''): any {
        if (!Array.isArray(value)) {
            return value;
        }

        return value.join(separator);
    }
}
